import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { Flex, Text, Paragraph } from "@zillow/constellation";
import "react";
import { useFormContext } from "react-hook-form";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import { useLastValidAmortizationValues } from "./AmortizationCalculator.utils.esm.js";
const OUTPUTS = [{
  label: "Total principal",
  accessor: "totalPrincipal",
  fontColor: "backgroundDarkGreen"
}, {
  label: "Total interest",
  accessor: "totalInterest",
  fontColor: "backgroundDarkAqua"
}, {
  label: "Principal & interest",
  accessor: "totalPayment",
  fontColor: "backgroundDarkPurple"
}];
const AmortizationPaymentSummary = () => {
  const form = useFormContext();
  const lastValidValues = useLastValidAmortizationValues(form);
  return /* @__PURE__ */ jsxs(Flex, { flex: "1", alignItems: "center", display: "flex", justifyContent: "center", flexDirection: "column", marginTop: "md", "aria-live": "polite", "aria-atomic": "true", width: "100%", children: [
    /* @__PURE__ */ jsx(Text, { fontType: "h4", as: "h2", "font-weight": "normal", children: "Estimated monthly payment" }),
    /* @__PURE__ */ jsx(Text, { fontType: "h2", marginBottom: "sm", children: getWholeDollars(lastValidValues.calculations.monthlyPayment) }),
    OUTPUTS.map(({
      label,
      accessor,
      fontColor
    }, index) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Flex, { display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "xs", marginBottom: "xs", last: index === OUTPUTS.length - 1, style: {
      borderBottom: index !== OUTPUTS.length - 1 ? `1px solid #A7A6AB` : null,
      width: "80%"
    }, children: [
      /* @__PURE__ */ jsx(Paragraph, { children: label }),
      /* @__PURE__ */ jsx(Text, { fontColor, fontType: "h4", children: getWholeDollars(lastValidValues.calculations[accessor]) })
    ] }, accessor) }))
  ] });
};
export {
  AmortizationPaymentSummary as default
};
